import { readAdminSessionUser } from './settingsSessionUser.js';

export function approvalUserName(user, fallback = 'un valideur') {
  if (!user) return fallback;
  const full = `${String(user.prenom || '').trim()} ${String(user.nom || '').trim()}`.trim();
  return full || user.email || fallback;
}

/**
 * Aligné backend mustBeApproved (devis) :
 * - montant ignoré
 * - !sendBypass → approval
 * - sinon remise > 0 → gate autonomie remise + seuil
 */
export function quoteMustBeApprovedClient({
  canSendWithoutApproval,
  canDiscountWithoutApproval,
  maxDiscountBps = 0,
  discountThresholdBps = null,
} = {}) {
  if (!canSendWithoutApproval) return true;
  const discount = Number(maxDiscountBps) || 0;
  if (discount <= 0) return false;
  if (!canDiscountWithoutApproval) return true;
  if (discountThresholdBps == null || discountThresholdBps === '') return false;
  const threshold = Number(discountThresholdBps);
  if (!Number.isFinite(threshold)) return false;
  return discount > threshold;
}

/**
 * Avant création du devis (éditeur).
 * maxDiscountBps optionnel : si fourni, applique aussi la policy remise.
 */
export function sessionNeedsQuoteApproval(
  user = readAdminSessionUser(),
  { maxDiscountBps = 0, discountThresholdBps } = {},
) {
  if (!user || user.role !== 'NR2J_STAFF') return false;
  const perms = Array.isArray(user.platformPermissions) ? user.platformPermissions : [];
  const threshold = discountThresholdBps !== undefined
    ? discountThresholdBps
    : (user.discountApprovalThresholdBps ?? null);
  return quoteMustBeApprovedClient({
    canSendWithoutApproval: perms.includes('NR2J_QUOTES_SEND_WITHOUT_APPROVAL'),
    canDiscountWithoutApproval: perms.includes('NR2J_QUOTES_DISCOUNT_WITHOUT_APPROVAL'),
    maxDiscountBps,
    discountThresholdBps: threshold,
  });
}

/**
 * Persiste les permissions effectives fraîches (GET /nr2j/me/access) dans admin_user
 * et notifie Layout / éditeurs (évite session stale après toggle autonomie).
 */
export function applyPlatformAccessToSession(access) {
  const permissions = Array.isArray(access?.permissions) ? access.permissions : [];
  const fresh = readAdminSessionUser() || {};
  const next = {
    ...fresh,
    platformProfile: access?.platformProfile ?? fresh.platformProfile ?? null,
    platformPermissions: permissions,
    discountApprovalThresholdBps:
      access?.discountApprovalThresholdBps !== undefined
        ? access.discountApprovalThresholdBps
        : (fresh.discountApprovalThresholdBps ?? null),
  };
  try {
    localStorage.setItem('admin_user', JSON.stringify(next));
  } catch {
    /* ignore quota */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('authUserUpdated', { detail: next }));
  }
  return next;
}

const APPROVAL_ERROR_MESSAGES = {
  APPROVER_NOT_FOUND: 'Aucun valideur disponible pour le moment. Contactez votre responsable ou un administrateur.',
  APPROVAL_ALREADY_PENDING: 'Ce devis est déjà en attente de validation.',
  PERMISSION_DENIED: 'Vous n’avez pas l’autorisation de soumettre ce devis à validation.',
  APPROVAL_REQUIRED: 'Ce devis doit être validé avant envoi. Soumettez-le pour validation.',
};

export function approvalErrorMessage(error, fallback) {
  const code = error?.code || error?.data?.error?.code;
  return APPROVAL_ERROR_MESSAGES[code] || error?.message || fallback;
}

export function isApprovalRequiredError(error) {
  return (error?.code || error?.data?.error?.code) === 'APPROVAL_REQUIRED';
}
